import { createContext } from "react";

const OrderListContext = createContext({});

export default OrderListContext;
